import { z } from "zod";

export const securePrintAuthenticationTypeSchema = z.enum(["ApiKey", "BasicAuth", "OAuth"]);

export type SecurePrintAuthenticationType = z.infer<typeof securePrintAuthenticationTypeSchema>;
